/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { createAsyncAction } from 'Helpers/redux'
import { APP } from 'Configs/App'
import { apiCall } from './api'

export const GET_TRANSFERWISE_ACCOUNT_REQUIREMENTS = createAsyncAction(
  'GET_TRANSFERWISE_ACCOUNT_REQUIREMENTS'
)
// export const getTransferwiseAccountRequirements = (
//   currency: string,
//   callback: () => void
// ) =>
//   apiCall({
//     method: 'get',
//     endpoint: `/transferwise/account-requirements/${currency}`,
//     types: GET_TRANSFERWISE_ACCOUNT_REQUIREMENTS,
//     callback,
//   })

export const getTransferwiseAccountRequirements = (
  currency: string,
  callback: () => void
) =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/payout/transferwise/account-requirements/${currency}`,
    types: GET_TRANSFERWISE_ACCOUNT_REQUIREMENTS,
    callback,
  })

export const GET_RECIPIENT_BANK_DETAILS = createAsyncAction(
  'GET_RECIPIENT_BANK_DETAILS'
)
export const getRecipientBankDetails = () =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/payout/transferwise/recipient`,
    types: GET_RECIPIENT_BANK_DETAILS,
  })

export const GET_IS_RECIPIENT_CHECKING_NEEDED = createAsyncAction(
  'GET_IS_RECIPIENT_CHECKING_NEEDED'
)
export const getIsRecipientCheckingNeeded = () =>
  apiCall({
    method: 'get',
    endpoint: '/transferwise/is-recipient-checking-needed',
    types: GET_IS_RECIPIENT_CHECKING_NEEDED,
  })

export const GET_CURRENCIES = createAsyncAction('GET_CURRENCIES')
export const getCurrencies = () =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/payout/transferwise/currencies`,
    types: GET_CURRENCIES,
  })

export const GET_COUNTRIES = createAsyncAction('GET_COUNTRIES')
export const getCountries = () =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/payout/transferwise/countries`,
    types: GET_COUNTRIES,
  })

export const SPECIFY_TRANSFERWISE_ACCOUNT_REQUIREMENTS = createAsyncAction(
  'SPECIFY_TRANSFERWISE_ACCOUNT_REQUIREMENTS'
)
export const specifyTransferwiseAccountRequirements = (
  currency: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  type: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  details: any,
  callback: () => void
) =>
  apiCall({
    method: 'post',
    endpoint: `${APP.TIKTOK_SERVER}/payout/transferwise/account-requirements/quote`,
    query: {
      currency,
      type,
      details,
    },
    types: SPECIFY_TRANSFERWISE_ACCOUNT_REQUIREMENTS,
    callback,
  })

export const SET_REQUIREMENTS_TO_INITIAL_STATE =
  'SET_REQUIREMENTS_TO_INITIAL_STATE'
export const setRequirementsToInitialState = () => ({
  type: SET_REQUIREMENTS_TO_INITIAL_STATE,
  payload: [],
})

export const ADD_TRANSFERWISE_RECIPIENT = createAsyncAction(
  'ADD_TRANSFERWISE_RECIPIENT'
)
export const addTransferwiseRecipient = (
  currency: string,
  type: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  details: any,
  callback: () => void
) =>
  apiCall({
    method: 'post',
    endpoint: `${APP.TIKTOK_SERVER}/payout/transferwise/recipient`,
    query: {
      currency,
      type,
      details,
    },
    types: ADD_TRANSFERWISE_RECIPIENT,
    callback,
  })
